// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "GeneralView" + "." + "d78fff63745c0794caa0" + ".js";
};